import { columnAtOffset, PlanGrid } from "../models/plan-scale";

/** Высота строки сотрудника, px. Должна совпадать с $row-height в plan-vars.scss */
export const ROW_HEIGHT = 40;

/** Ширина колонки с именем, px */
export const NAME_WIDTH = 240;

/** Боковой отступ подложки отдела, px. Должен совпадать с $section-padding в plan-vars.scss */
export const SECTION_PADDING = 12;

/** CSS-классы, по которым interact.js находит элементы (делегирование) */
export const BLOCK_CLASS = "wp-block";
/** Прошлые блоки: таскать нельзя, но продлить вправо можно */
export const PAST_BLOCK_CLASS = "wp-block-past";
export const SELECTION_CLASS = "wp-selection";
export const TRACK_CLASS = "wp-track";
/** Ручки растягивания блока — по ним interact определяет край */
export const HANDLE_LEFT_CLASS = "wp-handle-l";
export const HANDLE_RIGHT_CLASS = "wp-handle-r";
export const DRAG_ACTIVE_CLASS = "wp-dragging";
export const DROP_ACTIVE_CLASS = "wp-drop-active";
/** Строка, из которой тянут: поднимаем её над соседними, чтобы отрезок было видно */
export const SOURCE_ACTIVE_CLASS = "wp-drag-source";
/** Идёт протяжка рамки выделения — меняем курсор на сетке */
export const SELECTING_CLASS = "wp-selecting";

export interface DragPayload {
    rowIndex: number;
    start: number;
    length: number;
}

export function readPayload(element: Element): DragPayload | null {
    const rowIndex = Number(element.getAttribute("data-row"));
    const start = Number(element.getAttribute("data-start"));
    const length = Number(element.getAttribute("data-length"));

    if (!Number.isFinite(rowIndex) || !Number.isFinite(start) || !Number.isFinite(length)) {
        return null;
    }

    return { rowIndex, start, length };
}

/**
 * Отношение экранных пикселей к логическим: дорожка нарисована шириной сетки,
 * а CSS-зум страницы её масштабирует — поэтому считаем от реальных размеров.
 */
export function trackScale(track: Element, grid: PlanGrid): number {
    const rect = track.getBoundingClientRect();

    return grid.totalWidth > 0 ? rect.width / grid.totalWidth : 1;
}

/** Колонка под курсором. Ширина дня непостоянна, поэтому ищем по офсетам */
export function columnAt(track: Element, clientX: number, grid: PlanGrid): number {
    const rect = track.getBoundingClientRect();
    const scale = trackScale(track, grid);
    const x = (clientX - rect.left) / (scale || 1);

    return columnAtOffset(grid, x);
}
